export enum EPermissions {
  ALERTING = 'user:alerting',
  DOCS = 'user:docs',
  MCP = 'user:mcp',
  MODELING = 'user:modeling',
  MONITORING = 'user:monitoring',
  STABLECOINS = 'user:stablecoins',
}
